
export const commonFileSuffix = [
  ".js", ".ts", ".css", ".html", ".json", ".xml", ".rs",
  ".java", ".c", ".cpp", ".h", ".go", ".swift", ".php",
  ".scss", ".less", ".yaml", ".yml", ".sql", ".py",
  ".txt", ".md", ".csv", ".log", ".local",
  ".jpg", ".jpeg", ".png", ".gif", ".bmp",
  ".mp4", ".avi", ".mov", ".mkv",
  ".docx", ".xlsx", ".pptx", ".doc", ".ppt", ".xls",
  ".zip", ".rar", ".tar", ".gz",
  ".7z", ".iso", ".dmg", ".exe",
  ".apk", ".bat", ".psd",
]